import React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { FileExcelOutlined } from "@ant-design/icons";

import "./DownloadExcel.less";

export const DownloadExcel = React.memo(({ handleDownload, isLoading }) => {
  if (isLoading) {
    return <Spin className="align-self-center icon-primary" indicator={<LoadingOutlined spin />} />;
  }

  return (
    <FileExcelOutlined
      onClick={handleDownload}
      className="align-self-center icon-primary excel-icon"
    />
  );
});
